module.exports = __webpack_public_path__ + "img/309.e85ade6c.jpg";